export default __webpack_public_path__ + "static/hialexacase2-0bc35741c85204d576e19a11c6119316.png";